import { Component, OnInit, Inject, OnDestroy, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { UserProfile } from './model/user-profile';
import { AuthService } from './core/auth.service';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart, RouterEvent } from '@angular/router';
import { fadeAnimation } from './animation';
import { UserInfo } from './userInfo';
import { Spinkit } from 'ng-http-loader';
import { AppConfigService } from './reactive-forms/services/app-config.service';
import { parseNumber } from '@progress/kendo-angular-intl';
import { DOCUMENT } from '@angular/common';
import { AdminRouteGuard } from './core/admin-route.guard';
import { SharedHandlersService } from './shared/shared-handlers.service';
import { SignalRHelperService } from './shared/services/SignalRHelper.service';
import * as signalR from '@aspnet/signalr';
import { BuildPreCachedURlsService } from './shared/services/BuildPre-CachedURLs.service';
import { ShareDataService } from './shared/services/ShareDateService';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core';
import { MykendoLoader } from './reactive-forms/components/KendoLoader/KendoLoader';
import { SBHttpServicesService } from './shared/services/sbhttp-services.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ErrorDetailsService } from 'bi-modules';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';
import { HttpService } from 'src/app/shared/services/HttpClientServices/Http.service';
import { ErpawareCheckService } from './shared/services/erpaware-check.service';
import { LoginService } from './login/login.service';
import { data } from 'jquery';
import { SalesBuzzParams } from './shared/Enums/SalesOrderParams';
import localeFr from '@angular/common/locales/fr';
import localeFa from '@angular/common/locales/fa';
import { Languges } from './Languages';
import { LicenseState } from './about/enums/LicenseState';
import { AlertsService } from './shared/services/alertService/alerts.service';

export let browserRefresh = false;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeAnimation]
})

export class AppComponent implements OnInit, AfterViewInit {
  public currentPage = "currentPage"
  isSupervisor:any
  width: number;
  toggleListOfErrors: boolean = true;
  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    let count = 0;

    let oldCount = localStorage.getItem("tabsCount");
    if (oldCount == undefined || oldCount == null) {
      oldCount = "0";
    }
    count = parseInt(oldCount);
    count = count - 1;
    localStorage.setItem("tabsCount", count.toString());
    this.isRefreshed = true;
    if (count == 0) {//last tab to close then remove user info
      let jwt = localStorage.getItem('jwt');
      let userinfo = localStorage.getItem('userinfo');
      if (jwt != null) {
        sessionStorage.setItem("jwt", jwt);
        sessionStorage.setItem("userinfo", userinfo);
      }
      localStorage.removeItem('jwt');
      localStorage.removeItem('userinfo');
      localStorage.removeItem("tabsCount");
    }
  }
  keysToKeep = ["BrowserType", "BOToken", "FWToken", "userinfo", "jwt", "redirectTo",
    "isRightToLeft", "lang", "tabsCount", "IgnorSecurity", "ODataToken"];
  Myspinner = MykendoLoader;
  userProfile: UserProfile;
  spinnerStyle = Spinkit;
  isRightToLeft: string = "ltr";
  public _userinfo: any = UserInfo;
  public userImage: string = '';
  public hide: boolean = false;
  subscription: Subscription;
  isRefreshed: boolean = false;
  ODataToken: string;
  public searchData: any[] = [];
  public Vesrion: string;
  showSideBar: boolean = true;
  @ViewChild("drawer") drawer: any;

  public routesZoomScreens80 = ["SalesOrder", "CustomerDefinition", "PromotionDefinition"]
  constructor(
    private messages: MessageService,
    private _authService: AuthService,
    private _authJWTService: AdminRouteGuard,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private Alert: AlertsService,
    private environment: AppConfigService,
    public Shared: SharedHandlersService,
    private _signalrHelper: SignalRHelperService,
    public _shareDataService: ShareDataService,
    public loginService: LoginService,
    private httpServiceAPI: HttpService,
    private _ErpawareCheckService: ErpawareCheckService,
    public lang: Languges,
    @Inject(DOCUMENT) private document: Document, public translate: TranslateService, private httpService: SBHttpServicesService, private breakpointObserver: BreakpointObserver, public errorDetailsService: ErrorDetailsService, public _HttpClient: HttpClient) {
      translate.addLangs(['ar', 'en','fr','fa']);
    const browserLang = localStorage.getItem("lang") || 'en';
    registerLocaleData(this.lang.langItems.find(l=>l.preposition == browserLang ).localeData, browserLang);
    translate.use(browserLang);
    this.subscription = _router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !_router.navigated;
      }
    });
    

  }
  public isValidLicense;
  ngAfterViewInit() {
    const hideSideBar = this.activatedRoute.snapshot.queryParamMap.get('hide');
    const routedToken = this.activatedRoute.snapshot.queryParamMap.get('token');
    hideSideBar === 'true' ? this.showSideBar = false : this.showSideBar = true;
    if (routedToken) { localStorage.setItem('ODataToken', routedToken); }

    this.httpServiceAPI.get('api/License/CheckLicense').subscribe(res=>{
      if(res){
        if(res[0] >= LicenseState.Essential){
          this.isValidLicense = 1;
        }
        else {
          this.loginService.isLoggedIn = false;
          if(res[0] == LicenseState.NoLicenseFile){
            this.Alert.showAlertMessage(this.translate.instant('InvalidlicenseFile'),0);
            this.isValidLicense = -1;
          }
          else if(res[0] == LicenseState.InvalidApplicationPath){
            this.Alert.showAlertMessage(this.translate.instant('InvalidApplicationPath'),0);
            this.isValidLicense = -1;
          }
          else if(res[0] == LicenseState.InvalidMachineKey){
            this.Alert.showAlertMessage(this.translate.instant('InvalidMachineKey'),0);
            this.isValidLicense = -1;
          }
          else if(res[0] == LicenseState.InvalidCertificateFile){
            this.Alert.showAlertMessage(this.translate.instant('InvalidCertificateFile'),0);
            this.isValidLicense = -1;
          }
          else if(res[0] == LicenseState.OldVersion){
            this.Alert.showAlertMessage(this.translate.instant('OldVersion'),0);
            this.isValidLicense = -1;
          }
          else if(res[0] == LicenseState.ServerTypeError){
            this.Alert.showAlertMessage(this.translate.instant('ServerTypeError'),0);
            this.isValidLicense = -1;
          }
        }
      }
    })
    // const scaleOutQuery = this.breakpointObserver.observe('(min-width: 768px) and (max-width: 1440px)');


    //   scaleOutQuery.pipe(
    //     map((result) => result.matches)
    //   ).subscribe((matches) => {
    //     const mainDiv = document.getElementById("main-content");
    //     const navbar = document.getElementById("navbar-custom");
    //     const sideMenu = document.getElementById("menu");
    //     if (matches) {
    //       if (mainDiv && this.routesZoomScreens80.includes(this.currentPage)) (mainDiv.style as any).zoom = 1 / (1.25);
    //       if (navbar && this.routesZoomScreens80.includes(this.currentPage)) {
    //         (navbar.style as any).zoom = 1 / (1.25);
    //       }
    //     } else {
    //       if (mainDiv) (mainDiv.style as any).zoom = 1;
    //       if (navbar) {
    //         (navbar.style as any).zoom = 1;
    //       }
    //     }
    //   });

  }


  ngDoCheck() {
    this.ODataToken = localStorage.getItem('ODataToken');
    // let box = document.getElementById('menu');
    // console.log(box?.clientWidth);

    // if(box) this.width = 96 - box?.clientWidth;
  }

  @ViewChild('nonBindingDrop', { static: true }) myDropdown: any;
  async ngOnInit() {
    //clear alerts list if naviate to another screen
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.Shared.alerts = [];
      });
    //---------------------Record time of load and compare it with close or referesh time to close the screen with auth info removal ---------


    // let oldCount = localStorage.getItem("tabsCount");
    // if (oldCount == undefined || oldCount == null) {
    //   oldCount = "0";
    // }
    // count = parseInt(oldCount);
    // if (count < 0) {
    //   count = 0;
    // }
    // count = count + 1;
    // localStorage.setItem("tabsCount", count.toString());

    //--------------------End check close window-------------------------------------------------

    this.isRightToLeft = localStorage.getItem("isRightToLeft");
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['hide'] == "true" || params['screenID'] == "151") this.hide = true;
      else this.hide = false;
    });

    this._shareDataService.isUserLoggedIn.subscribe(value => {
      this.isRightToLeft = localStorage.getItem("isRightToLeft");
    });

    UserInfo.BrowserType = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent) ? 1 : 0;
    if (UserInfo.BrowserType == 1) {
      if (!localStorage.getItem("BrowserType"))
        localStorage.setItem("BrowserType", "1");
    }
    else {
      if (!localStorage.getItem("BrowserType"))
        localStorage.setItem("BrowserType", "0");
    }

    if (window.location.href.indexOf('?postLogout=true') > 0) {
      this._authService.signoutRedirectCallback().then(() => {
        let url: string = this._router.url.substring(
          0,
          this._router.url.indexOf('?')
        );
        this._router.navigateByUrl(url);
      });
    }
    var userdata = localStorage.getItem("userinfo");
    if (userdata) {
      var user = JSON.parse(localStorage.getItem("userinfo"));
      await this.loadUserClaims(user);
      if (UserInfo.Language == 1) {
        this.messages.notify(true);
      }
      else {
        this.messages.notify(false);
      }
    }
    else {
      this.messages.notify(false);
    }

    this.getSettings()
    this.getPrecision()
    this._signalrHelper.EstablishConnection();
   
  }


  // private hubConnection: signalR.HubConnection
  // public startConnection = () => {
  //   this.hubConnection = new signalR.HubConnectionBuilder()
  //     .withUrl('http://localhost:56653/broadcasthub')
  //     .build();
  //   this.hubConnection
  //     .start()
  //     .then(() => console.log('Connection started'))
  //     .catch(err => console.log('Error while starting connection: ' + err))
  // }

  async logout() {
    // Redirecting to the same page
    localStorage.setItem('redirectTo', window.location.href);
    var i;
    let CurrentODataToken = localStorage.getItem('ODataToken');
    let RequestBody = { "Token": CurrentODataToken };
    this.httpServiceAPI.post(`${this.environment.oDataApi}/EndODataToken`, RequestBody).subscribe(
      res => {
      })
    this.httpServiceAPI.post(`${this.environment.oDataApi}/api/Authenticate/logout`, {}).subscribe(
      res => {
      })
    for (i in localStorage) {
      if (localStorage.hasOwnProperty(i)) {
        if (i.match('FilterValues') || (!'FilterValues' && typeof i === 'string')) {
          localStorage.removeItem(i);
        }
      }
    }
    localStorage.removeItem("userinfo");
    localStorage.removeItem("jwt");
    localStorage.removeItem("ODataToken");
    localStorage.removeItem("refreshToken");
    sessionStorage.clear();
    this._authService.resetUser();
    await this._router.navigate(["login"]);
  }

  getUserName() {
    return UserInfo.UserName;
  }

  getBusinessUnit() {
    if (UserInfo.Language == 2)
      return UserInfo.BusinessUnitName + ' (' + UserInfo.BUID + ')';
    else return UserInfo.BusinessUnitAName + ' (' + UserInfo.BUID + ')';
  }

  async loadUserClaims(user: any) {
    //
    if (user.BusinessUnit)
      UserInfo.BUID = user.BusinessUnit;
    if (user.BusinessUnitName)
      UserInfo.BusinessUnitName = user.BusinessUnitName;
    if (user.BusinessUnitAName)
      UserInfo.BusinessUnitAName = user.BusinessUnitAName;
    if (user.Username)
      UserInfo.UserName = user.Username;
    if (user.Language)
      UserInfo.Language = this.Shared.SetUserLanguage(user.Language);
    if (user.UserCode) {
      UserInfo.CurrentSalesmanNo = user.UserCode;
      UserInfo.UserCode = user.UserCode;
      UserInfo.UserName = user.Username;
    }
    if (user.Token) {
      UserInfo.AccessToken = user.Token;
      localStorage.setItem("jwt", user.Token);
    }
    if (localStorage.getItem("BrowserType")) {
      UserInfo.BrowserType = parseNumber(localStorage.getItem("BrowserType"));
    }
    else { UserInfo.BrowserType = 0; }

    if (user) {
      localStorage.setItem("userinfo", JSON.stringify(user));
    }
  }

  isLoggedIn() {
    return this._authJWTService.isLoggedIn();//this._authService.isLoggedIn();
  }

  loadStyle(styleName: string, clienttheme: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      clienttheme
    ) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = clienttheme;
      style.rel = 'stylesheet';
      style.href = `${styleName}`;
      style.type = "text/css";
      head.appendChild(style);
    }
  }

  GetLayout() {
    return UserInfo.BrowserType;
  }

  ReloadWindow() {
    if (UserInfo.BrowserType == 1) {
      this.keysToKeep.push("HeaderObject_" + this.Shared.CurrentScreenID);
      this.keysToKeep.push("HeaderObject");
    }
    for (var a in localStorage) {
      if (this.keysToKeep.includes(a) == false) {
        localStorage.removeItem(a);
      }
    }
    window.location.reload();
  }

  async getSettings() {
    //var res = await this.httpService.httpGetRequest(this.environment.apiRoot + 'api/Schema/GetSettings/');
    // this.Vesrion = res.data?.['Version'];
  }

  styleErrorMsg(): Object {
    if (this._userinfo['Language'] == 1) {
      return { float: 'left', margin: '4px 0px 0px 20px' }
    }
    return { float: 'right', margin: '4px 20px 0px 0px' }
  }

  changeOfRoutes() {
    if (!(this._router.url.includes('/login'))) {
      this._ErpawareCheckService.checkErpawarePermission(this._router.url);
    }
  }

  getPrecision() {
    this.httpServiceAPI.get(`VU_ConfigParams?$filter=PARAM_ID eq ${SalesBuzzParams.Precision}&$select=PARAM_ID,PARAM_VALUE`).subscribe(
      {
        next(value: any) { localStorage.setItem("Precision", value.value[0].PARAM_VALUE) },
        error(err) { console.error('Observable emitted an error: ' + err); },
      }
    )
  }

  addPathsToMenu() {


  }
}
